import { render, staticRenderFns } from "./RightCard.vue?vue&type=template&id=4fc2fef9&"
import script from "./RightCard.vue?vue&type=script&lang=js&"
export * from "./RightCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports